export default __webpack_public_path__ + "static/media/failed-transaction.222a2642.svg";